// extracted by mini-css-extract-plugin
export default {"container":"PhaseDependency_container__R1G94"};